import * as React from 'react'
import {connect} from "react-redux"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {EntityField} from "../../core/genericdocuments/EntityField"
import {LookupDataRow} from "../../services/LookupDataRow"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {FieldView} from "../components/FieldView"
import {ApplicationState} from "../../store"
import {Button} from "@material-ui/core"
import SaveIcon from "@material-ui/icons/Save"
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab"
import {actionPositionSave, actionPositionFetch} from "../../store/positions/actions"
import {actionActiveTabTitle} from '../../store/tabs/actions'
import {Tab} from '../Tab'
import {Validator} from '../../core/Validator'
import {PositionDescriptor} from '../../models/Position'
import {Utility} from '../../core/Utility'
import {t} from "../../core/localization"
import {Department} from "../../models/Department"
import {positionFieldsDescriptor} from "./PositionFields"
import {Position} from "../../models/Position"
import {ContractDescriptor} from "../../models/Contract";

export interface PositionTabProps extends BaseTabProps{
	tab: Tab
	departments: Department[]
}

export interface PositionTabState extends BaseTabState{
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active,
		departments: state.departments.list
	}
}

class PositionTab extends BaseTab<PositionTabProps, PositionTabState> {

	constructor(props: PositionTabProps) {
		super(props)
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: '', validation: { valid: true, fields: [] }}
    }

	componentWillMount() {

		if (this.props.item.id)
			actionPositionFetch(this.props.item)
	}

	componentWillReceiveProps(nextProps: PositionTabProps) {
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderForm()}
				{this.renderControls()}
			</div>
		)
	}

	renderForm(): React.ReactNode {

		let descriptor: EntityFieldsDescriptor<any> = positionFieldsDescriptor

		// todo: ova render metoda će biti identična za sve, ja bih je prebacio u BaseTab
		return (<div className="create-form">
		{
			descriptor && descriptor.createFormFields.map(
				(entityField: EntityField<any>, index: number) => {
					const fieldName = entityField.name.toString()
					let value = Utility.formatString(this.getItemFromTabState(fieldName))
					return (
						<div style={{ marginBottom: "0px", padding: "0px" }}>
							{<FieldView value={value}
									autoFocus={index === 0} field={entityField} formState={null}
									setFormState={null}
									handleInputChange={(fieldName, value) => this.handleItemGenericInputChange(fieldName, value)}
									validationState={this.state.validation}
									lookupData={this.getLookupData.bind(this)}
								/>}
							</div>
						)
						}
				)
			}
		</div>
		)
	}

	getLookupData(lookupEntity: LookupEntities): LookupDataRow[] {
		if(lookupEntity == LookupEntities.Departments) return this.props.departments.map((department: Department) => {return {label: department.title, value: department.id}})
	}

	renderControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	onSaveClick () {
		let itemToSave = this.getItemFromTabState()
		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, PositionDescriptor)

		if (validation.valid) {
			actionPositionSave(itemToSave)
			actionActiveTabTitle(t.Position + ': ' + this.getItemFromTabState('title'))
		}
		this.setState({ ...this.state, validation: validation });

	}
}

export default connect(mapStateToProps)(PositionTab)
